import styles from "../styles/components/loaders.module.css";

function InputLoader() {
  return (
    <div className={styles.container}>
      <div className={styles.entry1}>e1</div>
      <div className={styles.entry2}>e1</div>
      <div className={styles.entry2}>e1</div>
    </div>
  )
}

export default InputLoader
